export enum MagazineCategory {
  OurWorld = 'magazine-category-our-world',
  MyLife = 'magazine-category-my-life',
  YourCity = 'magazine-category-your-city',
}
